// eslint-disable-next-line import/prefer-default-export
export const PAGE_DEFAULT = '/home';



// WEBPACK FOOTER //
// ./src/router/routerConf.js